import { useContext, useState } from 'react';

import JsFileDownloader from 'js-file-downloader';
import { clone } from 'ramda';

import { useSnackbar } from 'hooks/useSnackbar';
import { getArchiveWithImages } from 'utils/asset';

import LandingPageContext from '../../contexts/LandingPageContext';
import { IGalleryBlockProps } from './types';

export function useGallery({ data: blockData }: IGalleryBlockProps) {
  const onSnackbar = useSnackbar({ time: 2000 });
  const { page } = useContext(LandingPageContext);
  const [checkedIds, setCheckedIds] = useState<string[]>([]);
  const isAllChecked = checkedIds.length === blockData.data.photos.length;
  const handleCheckId = (id: string) => {
    const newCheckedIds = clone(checkedIds);
    const index = newCheckedIds.findIndex((it) => it === id);

    if (index > -1) {
      newCheckedIds.splice(index, 1);
    } else {
      newCheckedIds.push(id);
    }

    setCheckedIds(newCheckedIds);
  };
  const handleCheckAll = () => {
    if (isAllChecked) {
      setCheckedIds([]);
    } else {
      setCheckedIds([...blockData.data.photos]);
    }
  };

  const handleDownload = () => {
    onSnackbar('Your download is in progress.');
    new JsFileDownloader({
      url: getArchiveWithImages(checkedIds, page.id),
      filename: page.name + '_gallery.zip',
    }).catch(() => {
      onSnackbar('Error on downloading images', true);
    });
  };

  return {
    checkedIds,
    isAllChecked,
    handleCheckId,
    handleCheckAll,
    handleDownload,
  };
}
